import React from 'react';
import { RANGE_SLIDER_CLS } from '../constants';

/**
 * Labeled range slider row — label on left, slider in middle, formatted value on right.
 *
 * @param {Object}   props
 * @param {string}   props.label     — Label text
 * @param {number}   props.min       — Minimum value
 * @param {number}   props.max       — Maximum value
 * @param {number}   props.step      — Step increment
 * @param {number}   props.value     — Current value
 * @param {Function} props.onChange   — (newValue: number) => void
 * @param {Function} [props.format]  — Value display formatter (default: raw value)
 * @param {string}   [props.labelWidth] — Tailwind width class for label (default: "w-16")
 * @param {string}   [props.valueWidth] — Tailwind width class for value (default: "w-14")
 */

export function SliderRow({
  label,
  min,
  max,
  step,
  value,
  onChange,
  format,
  labelWidth = 'w-16',
  valueWidth = 'w-14',
}) {
  return (
    <div className="flex items-center gap-2">
      <span className={`text-[10px] text-white/40 ${labelWidth} shrink-0`}>{label}</span>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className={RANGE_SLIDER_CLS}
      />
      <span className={`text-[10px] text-white/50 ${valueWidth} text-right tabular-nums`}>
        {format ? format(value) : value}
      </span>
    </div>
  );
}
